/**
 * Settings > Branding (configurable-branded-templates, FR-14 / FR-12). The route token is the bare
 * upper-case word `BRANDING`; the key is a WRITE key, so an acting-as (support) session never
 * receives it. Granted by acl-svc to the `agency-admin` and `client-admin` catalogue roles. UX-only:
 * form-svc enforces `branding:configure` on every brand-kit operation.
 */
export const BrandingAclKeys = {
  configure: 'branding:configure',
} as const;

export type BrandingAclKey = (typeof BrandingAclKeys)[keyof typeof BrandingAclKeys];
